import moment from 'moment';
import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 12,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
        {
            h: 8,
            static: true,
            w: 24,
            x: 0,
            y: 14,
            i: 'c3',
        },
    ],
    md: [
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
        {
            h: 8,
            static: true,
            w: 24,
            x: 0,
            y: 16,
            i: 'c3',
        },
    ],
    xs: [
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 20,
            static: true,
            w: 24,
            x: 0,
            y: 3,
            i: 'c2',
        },
        {
            h: 6,
            static: true,
            w: 24,
            x: 0,
            y: 23,
            i: 'c3',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {
        analysis_type: {
            label: 'future',
            value: 'future',
            path: '/review-all/cashflows/future',
            ga_event_name: 'Cashflows > Future',
        },
        maxDate: moment().year(2040).endOf('year'),
        analysis_types: [
            {
                label: 'historic',
                value: 'historic',
                path: '/review-all/cashflows/historic',
                ga_event_name: 'Cashflows > Historic',
            },
            {
                label: 'future',
                value: 'future',
                path: '/review-all/cashflows/future',
                ga_event_name: 'Cashflows > Future',
            },
        ],
    },
    components: [
        {
            name: 'page-header',
            key: 'c1',
            props: {
                header: {
                    title: 'cashflows',
                    path: '',
                },
                rhsComponents: [
                    {
                        name: 'mode-selector',
                        props: {},
                    },
                    {
                        name: 'date-range-picker',
                        props: {
                            visiblePeriods: [
                                '1y',
                                '3m',
                                'mtd',
                                'qtd',
                                'ytd',
                                '3me',
                                '6me',
                                '1ye',
                            ],
                            defaultPeriod: '1ye',
                        },
                    },
                    {
                        name: 'simple-filters',
                        props: {
                            filterApi: 'filters/cashflows',
                            dataKey: 'cashflows',
                        },
                    },
                ],
            },
        },
        {
            key: 'c2',
            name: 'cashflows-bar-chart',
            props: {},
            apiDetails: {
                endpoint: `charts/cashflows?cashflow_type=future&include_bond_repayment=true&`,
                endpointParams: {
                    to_date: '*,to_date',
                    from_date: '*,from_date',
                    parent_user_ids: 'parent_display_name',
                    child_user_ids: 'child_display_name',
                    contract_currencies: 'contract_currency',
                    user_asset_classes: 'user_asset_class',
                    types: 'type',
                },
            },
        },
        {
            key: 'c3',
            name: 'canopy-table',
            apiDetails: {
                endpoint: `cashflows?cashflow_type=future&include_bond_repayment=true&`,
                endpointParams: {
                    per_page: '*,per_page',
                    page: '*,page',
                    keyword: 'keyword',
                    to_date: '*,to_date',
                    from_date: '*,from_date',
                    parent_user_ids: 'parent_display_name',
                    child_user_ids: 'child_display_name',
                    contract_currencies: 'contract_currency',
                    user_asset_classes: 'user_asset_class',
                    types: 'type',
                    sort_column: 'sortColumn',
                    sort_direction: 'sortDirection',
                },
            },
            props: {
                headerText: '',
                requiredQueryFields: [
                    'include_bond_repayment',
                    'cashflow_type',
                ],
                dataKey: 'cashflows',
                title: '',
                showDownloadOn: ['desktop', 'tablet'],
                showFilterOn: [],
                columns: [
                    {
                        key: 'securityName',
                        otherKeys: ['ticker'],
                        width: 160,
                        type: 'splitCell',
                        headerText: 'ui.mm.table-headers.name',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'type',
                        type: 'text',
                        headerText: 'table-headers.type',
                        width: 200,
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                    },
                    {
                        key: 'parentDisplayName',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.parent-display-name',
                        canSort: true,
                        width: 200,
                    },
                    {
                        key: 'parentUsername',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.parent-username',
                        width: 200,
                    },
                    {
                        key: 'childDisplayName',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.child-display-name',
                        canSort: true,
                        width: 200,
                    },
                    {
                        key: 'childUsername',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.child-username',
                        width: 200,
                    },
                    {
                        key: 'userAssetClass',
                        type: 'text',
                        headerText: 'table-headers.asset-class',
                    },
                    {
                        key: 'maturity',
                        type: 'date',
                        headerText: 'table-headers.maturity',
                        canSort: true,
                    },
                    {
                        key: 'distribution',
                        type: 'amount',
                        colSpan: '1',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        headerText: 'table-headers.distribution',
                    },
                    {
                        key: 'contractCurrency',
                        type: 'text',
                        headerText: 'table-headers.ccy',
                        selectedByDefaultOn: ['desktop'],
                    },
                    {
                        key: 'displayQuantity',
                        type: 'amount',
                        headerText: 'table-headers.qty',
                        selectedByDefaultOn: ['desktop'],
                        canSort: true,
                    },
                    {
                        key: 'paymentDate',
                        type: 'date',
                        headerText:
                            'ui.mm.table-headers.estimated-payment-date',
                        selectedByDefaultOn: ['desktop'],
                        canSort: true,
                    },
                    {
                        key: 'cashflow',
                        type: 'amount',
                        headerText: 'table-headers.estimated-cashflow',
                        selectedByDefaultOn: ['desktop'],
                        canSort: true,
                    },
                    {
                        key: 'cashflowBaseCcy',
                        type: 'amount',
                        canSort: true,
                        headerText:
                            'ui.mm.table-headers.estimated-cashflow-with-ccy',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        headerTextVariables: [{ key: 'ccy', value: 'baseCcy' }],
                    },
                ],
                per_page: 25,
                ga_event_name: 'Review All Cashflows ',
            },
        },
    ],
};
